import {Component, EventEmitter, Input, OnInit, Output, ViewChild, forwardRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MainSustainabilityRatingAttribute} from '@app/shared/services/api/sustainability-ratings/ratings/sustainability-ratings.interface';
import {AceSelectComponent} from '../ace-select/ace-select.component';
import {SustainabilityRatingAttributeService} from '@app/shared/services/api/sustainability-ratings/sustainability-rating-attributes.service';
import {finalize} from 'rxjs';
import {I18nMessage} from '@app/shared/api/model/i18n';

@Component({
  selector: 'app-sustainability-rating-attribute-select',
  templateUrl: './sustainability-rating-attribute-select.component.html',
  styleUrls: ['./sustainability-rating-attribute-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SustainabilityRatingAttributeSelectComponent),
      multi: true
    }
  ],
  standalone: false
})
export class SustainabilityRatingAttributeSelectComponent implements OnInit, ControlValueAccessor {

  @Input() options: MainSustainabilityRatingAttribute[];
  @Input() placeholder: I18nMessage | string = {messageKey: "Attribute"};
  @Input() loading: boolean;
  @Input() hideSelected = true;
  @Input() appendTo: string;
  @Output() dataLoaded = new EventEmitter<MainSustainabilityRatingAttribute[]>();
  @ViewChild(AceSelectComponent, {static: true})
  private aceSelect: AceSelectComponent;

  constructor(private sustainabilityRatingAttributeService: SustainabilityRatingAttributeService) {}

  ngOnInit(): void {
    this.loadOptions();
  }

  writeValue(obj: MainSustainabilityRatingAttribute): void {
    this.aceSelect.writeValue(obj);
  }

  registerOnChange(fn: (attribute: MainSustainabilityRatingAttribute) => void): void {
    this.aceSelect.registerOnChange(fn);
  }

  registerOnTouched(fn: () => void): void {
    this.aceSelect.registerOnTouched(fn);
  }

  setDisabledState?(isDisabled: boolean): void {
    this.aceSelect.setDisabledState(isDisabled);
  }

  private loadOptions() {
    if (!this.options) {
      this.loading = true;
      this.sustainabilityRatingAttributeService.getAllSustainabilityRatingAttributes()
        .pipe(finalize(() => this.loading = false))
        .subscribe(sustainabilityRatingAttributes => {
          this.options = sustainabilityRatingAttributes;
          this.dataLoaded.emit(this.options);
        });
    } else {
      this.dataLoaded.emit(this.options);
    }
  }
}
